<template>
    <v-progress-linear indeterminate v-if="loading"/>
    <v-container fluid grid-list-md v-else class="pa-3">
        <v-layout class="align-center">
            <v-flex>
                <h2 class="headline">Vis kunde: {{ customer.name }}</h2>
            </v-flex>
            <v-spacer/>
            <v-flex shrink class="hidden-print-only">
                <v-btn text color="red" @click="remove" v-if="!customer.deleted_at">
                    <v-icon left>delete</v-icon>
                    Slett kunde
                </v-btn>
                <edit-customer-dialog @save="loadData" :customer-id="customer.id" v-if="!customer.deleted_at"/>
                <edit-car-dialog @save="loadData" :customer-id="customer.id" v-if="!customer.deleted_at"/>

                <v-btn text color="indigo" @click="print">
                    <v-icon left>print</v-icon>
                    Skriv ut
                </v-btn>

                <v-btn color="blue-grey" text @click="goBack">
                    <v-icon left>arrow_back</v-icon>
                    Tilbake
                </v-btn>
            </v-flex>
            <v-flex shrink class="hidden-screen-only">
                <v-label>{{ currentDate }}</v-label>
            </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-flex md4 lg3>
                <customer-card class="hidden-print-only" :customer="customer"/>

                <v-btn @click="showSMS = !showSMS" class="mt-2" color="indigo" dark>
                    <v-icon left small>send</v-icon>
                    Send SMS til kunde
                </v-btn>

                <v-card class="pa-3 mt-2 car-filter-container">
                    <car-filter @filter="applyFilter($event)" narrow customer/>
                </v-card>
            </v-flex>

            <v-flex md8 lg9>
                <car-table :customer-id="customer.id" ref="carTable"/>

                <SmsList :customer-id="customer.id" class="mt-2"></SmsList>
            </v-flex>
        </v-layout>

        <SmsDialog v-if="showSMS" :customer-id="customer.id" v-model="showSMS"></SmsDialog>
    </v-container>
</template>

<script>
import CustomerCard from '../helpers/CustomerCard';
import EditCustomerDialog from '../helpers/EditCustomerDialog';
import EditCarDialog from '../helpers/EditCarDialog';
import CarTable from '../helpers/CarTable';
import CarFilter from "../helpers/filter/CarFilter";
import moment from "moment";
import SmsDialog from "@/components/helpers/SmsDialog";
import SmsList from "@/components/helpers/SmsList";

export default {
    name: 'CustomerShow',
    components: {
        CustomerCard,
        EditCustomerDialog,
        EditCarDialog,
        CarTable,
        SmsDialog,
        CarFilter,
        SmsList
    },

    data() {
        return {
            loading: false,
            customer: null,
            showSMS: false
        }
    },

    created() {
        this.loadData();
    },

    methods: {
        goBack() {
            history.back();
        },
        loadData() {
            if (!this.customerId) return;

            this.loading = true;

            this.$http.get(`customers/${this.customerId}`).then(response => {
                this.customer = response.data.data;
            }).finally(() => this.loading = false);
        },

        remove() {
            let ok = confirm('Vil du virkelig slette denne kunden? Kunden kan bare slettes dersom den ikke har noen dekk på dekkhotellet for øyeblikket.');
            if (!ok) return;

            this.$http.delete(`customers/${this.customerId}`).then(response => {
                this.$root.addMessage(response.data.message, 'green');
                this.$router.push({name: 'CustomerIndex'});
            }).catch(error => {
                this.$root.addMessage(error.response.data.message, 'red');
            })
        },

        applyFilter(filter) {
            this.$refs.carTable.loadData(filter);
        },

        print() {
            window.print();
        }
    },

    watch: {
        customerId() {
            this.loadData();
        }
    },

    computed: {
        customerId() {
            return parseInt(this.$route.params.id);
        },
        currentDate() {
            return moment().format('DD.MM.YYYY')
        }
    }
}
</script>

<style>
@media print {
    .car-filter-container {
        box-shadow: none;
        padding: 0 !important;
    }
}
</style>
